export const workspaceTabs = [
    {
        label: 'Current Status',
        param: 'overview',
        roles: ['OWNER', 'ADMIN', 'USER', 'CONTRIBUTOR'],
    },
    {
        label: 'Analytics',
        param: 'analytics',
        roles: ['OWNER', 'ADMIN', 'USER', 'CONTRIBUTOR'],
    },
    // {
    //     label: 'Cases',
    //     param: 'cases',
    //     roles: ['OWNER', 'ADMIN', 'USER', 'CONTRIBUTOR'],
    // },
    {
        label: 'Import Wizard',
        param: 'data-sources',
        roles: ['OWNER', 'ADMIN', 'CONTRIBUTOR'],
    },
    {
        label: 'Settings',
        param: 'settings',
        roles: ['OWNER', 'ADMIN'],
    },
    {
        label: 'User Management',
        param: 'security',
        roles: ['OWNER', 'ADMIN'],
    },
];
